enum Language {
  ES = "es",
  CA = "ca",
  EN = "en",
};

export default Language;